import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=e376d6b2&"
import script from "./UserRoles.vue?vue&type=script&lang=js&"
export * from "./UserRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports